import { useMutation, useQueryClient } from '@tanstack/react-query';

const API_BASE = process.env.REACT_APP_API_BASE || '';

interface UpdateAttractionMetadataInput {
  id: string;
  rating: number;
  priority: string;
}

export function useUpdateAttractionMetadata() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, rating, priority }: UpdateAttractionMetadataInput) => {
      const response = await fetch(`${API_BASE}/api/admin/attractions/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rating, priority }),
      });
      if (!response.ok) throw new Error(`Failed to update attraction: ${response.status}`);
    },
    onMutate: (variables) => {
      queryClient.cancelQueries({ queryKey: ['admin-attractions'] });
      const previous = queryClient.getQueryData(['admin-attractions']);
      queryClient.setQueryData(['admin-attractions'], (old: any) => {
        if (!old) return old;
        return old.map((a: any) =>
          a.id === variables.id ? { ...a, rating: variables.rating, priority: variables.priority } : a
        );
      });
      return { previous };
    },
    onError: (err, variables, context) => {
      if (context?.previous) {
        queryClient.setQueryData(['admin-attractions'], context.previous);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-attractions'] });
    },
    retry: 1,
  });
}
